import DownloadDocument from "../procodocs/documents/controls/DownloadDocument";
import ShareLinkDocument from "../procodocs/documents/controls/ShareLinkDocument";
import ViewDocument from "../procodocs/documents/controls/ViewDocument";

import classes from './RecordsControls.module.css'
import SharedWith from "./sharedwith/SharedWith";
import RecordsUpload from "./RecordsUpload";

export default function RecordsControls({activeCase, userToken, item, docType, practiceItem, forWorkQ, managingAttyId}) {
   
    return <div className={classes.container}>
        {/* <LockUnlockDocument userToken={userToken} activeCase={activeCase} item={item}/> */}
        <ShareLinkDocument userToken={userToken} activeCase={activeCase} item={item} docType={docType} forRecords={true} practiceItem={practiceItem} forWorkQ={forWorkQ}/>
        <ViewDocument userToken={userToken} activeCase={activeCase} item={item} btnStyle='btn_simple' docType={docType}>
            <i className="ti ti-eye"></i>
        </ViewDocument>
        <DownloadDocument userToken={userToken} activeCase={activeCase} item={item} btnStyle='btn_simple' docType={docType}>
            <i className="ti ti-download"></i>
        </DownloadDocument>  
        {/* {!forWorkQ && (
            <SharedWith practiceItem={practiceItem} userToken={userToken} caseId={activeCase?.case?.id} forWorkQ={forWorkQ}/>
        )} */}
        <RecordsUpload practiceId={practiceItem.practice_id} managingAttyId={managingAttyId} practiceItem={practiceItem} activeCase={activeCase} forWorkQ={forWorkQ} isUpdate={true}/>
    </div>
}